module.exports = __webpack_public_path__ + "img/webmaster.e4562ca8.svg";